import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../services/api";
import "./GovernmentPortal.css";

const GovernmentRegister = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    fullName: "",
    mobile: "",
    email: "",
    password: "",
    officerCode: "",
    designation: "",
    officeName: "",
    district: "",
    area: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const submit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setSaving(true);
    try {
      await API.post("/auth/register/government", form);
      setMessage("Government portal user registered. You can login now.");
      setTimeout(() => navigate("/login"), 900);
    } catch (err) {
      setError(err?.response?.data?.message || "Registration failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="gov-auth-page">
      <form className="gov-auth-card" onSubmit={submit}>
        <div className="gov-auth-mark">
          <span className="material-symbols-outlined">account_balance</span>
        </div>
        <h1>Government Portal Registration</h1>
        <p>Area officer account for farmer thumb verification and supplier payment updates.</p>
        {message && <div className="gov-success">{message}</div>}
        {error && <div className="gov-error">{error}</div>}
        <div className="gov-form-grid">
          <input placeholder="Officer name" value={form.fullName} onChange={(e) => update("fullName", e.target.value)} required />
          <input placeholder="Mobile" value={form.mobile} onChange={(e) => update("mobile", e.target.value)} required />
          <input placeholder="Email" value={form.email} onChange={(e) => update("email", e.target.value)} />
          <input placeholder="Password" type="password" value={form.password} onChange={(e) => update("password", e.target.value)} required />
          <input placeholder="Officer code" value={form.officerCode} onChange={(e) => update("officerCode", e.target.value)} />
          <input placeholder="Designation" value={form.designation} onChange={(e) => update("designation", e.target.value)} />
          <input placeholder="Office name" value={form.officeName} onChange={(e) => update("officeName", e.target.value)} />
          <input placeholder="District" value={form.district} onChange={(e) => update("district", e.target.value)} />
          <input className="gov-span-2" placeholder="Area / mandi / center" value={form.area} onChange={(e) => update("area", e.target.value)} required />
        </div>
        <button className="gov-primary" type="submit" disabled={saving}>{saving ? "Creating..." : "Create Account"}</button>
        <Link className="gov-link" to="/login">Back to login</Link>
      </form>
    </div>
  );
};

export default GovernmentRegister;
